import FullWidthContentBlock from './full_width_content_block';
export default FullWidthContentBlock;
